<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs :title="$t('userProfile.frdiMlumatlar')"/>
      <div class="row">
        <div
            v-if="user"
            class="col-lg-8 "
        >
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-3">
                  <input
                      id="fileInput"
                      ref="file"
                      type="file"
                      style="display: none"
                      @change="setPhoto"
                  >
                  <img
                      :src="getPhoto(user.photo,'mediumCropped')"
                      alt=""
                      class="img-thumbnail rounded-circle w-100"
                  >
                  <div class="mt-2 text-center">
                    <button
                        class="btn btn-sm mr-2 btn-light-primary"
                        @click="selectPhoto"
                    >
                      <i class="fa fa-pencil"/>
                    </button>
                    <button
                        v-if="user.photo"
                        class="btn btn-sm mr-2 btn-light-danger"
                        @click.prevent="removeProfilePhoto"
                    >
                      <i class="fa fa-trash"/>
                    </button>

                    <div
                        v-if="uploadProgress >0 && uploadProgress <100"
                        class="progress"
                    >
                      <div
                          class="progress-bar progress-bar-striped progress-bar-animated"
                          role="progressbar"
                          aria-valuenow="75"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          :style="{width: `${uploadProgress}%`}"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-9">
                  <div>
                    <div class="lead font-weight-bold">
                      {{ user.name }} {{ user.surname }}
                    </div>
                    <div class="text-secondary">
                      {{ user.uniqueId }}
                    </div>
                  </div>
                  <hr>
                  <div>
                    <div class="text-secondary">
                      {{ $t('userProfile.telefon') }}
                    </div>
                    <div class="lead">
                      {{ user.phone }}
                    </div>
                  </div>
                  <hr>

                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <div class="text-secondary">
                        E-mail
                      </div>
                      <div class="lead">
                        {{ user.email }}
                      </div>
                    </div>
                    <div>
                      <button
                          class="btn btn-sm btn-light-primary"
                          @click="changeEmail"
                      >
                        <i class="fa fa-pencil"/>
                      </button>
                    </div>
                  </div>

                  <hr>
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <div class="text-secondary">
                        {{ $t('login.ifr') }}
                      </div>
                      <div class="lead">
                        *****
                      </div>
                    </div>
                    <div>
                      <button
                          class="btn btn-sm btn-light-primary"
                          @click="changePassword"
                      >
                        <i class="fa fa-pencil"/>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="card">
            <div class="card-body">
              <h4>{{ $t('userProfile.hesabmSil') }}</h4>
              <hr>
              <p>
                {{ $t('userProfile.hesabnzSildikdnSonraSizinXsiBilgilrinizSistemdnSil') }}
              </p>
              <p>
                <button
                    class="btn btn-light-danger"
                    @click.prevent="deleteAccount"
                >
                  {{ $t('userProfile.hesabmSil') }}
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->


    <b-modal
        id="modal-edit-password"
        centered
        :title="$t('login.ifrmiYenil')"
        :hide-footer="true"
        class="theme-modal"
    >
      <div>
        <form @submit.prevent="setPassword">
          <div class="mb-3">
            <label
                for="oldPassword"
                class="form-label"
            >{{ $t('passwordChange.yeniIfr') }}</label>
            <div class="input-group">
              <input
                  id="oldPassword"
                  v-model="password"
                  :type="`${passwordVisible?'text': 'password'}`"
                  class="form-control"
              >
              <div class="input-group-append">
                <button
                    type="button"
                    class="btn btn-light"
                    @click.prevent="passwordVisible=!passwordVisible"
                >
                  <i :class="`${passwordVisible?'fa fa-eye-slash': 'fa fa-eye'}`"/>
                </button>
              </div>
            </div>
          </div>

          <div class="progress mb-3">
            <div
                class="progress-bar"
                :class="`bg-${scorePassword.color}`"
                :style="{width: `${scorePassword.percent}%`}"
                role="progressbar"
                aria-valuenow="0"
                aria-valuemin="0"
                aria-valuemax="100"
            >
              {{ scorePassword.name }}
            </div>
          </div>


          <div
              v-if="scorePassword.percent>50"
              class="mb-3"
          >
            <button
                class="btn  btn-light-primary"
                type="submit"
            >
              {{ $t('login.ifrmiYenil') }}
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  changeEmail,
  deleteAccount,
  removeProfilePhoto, updateProfilePhoto, upload,
  userAccounts, userMe, userSetPassword,
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";
import {store} from "@/store";

export default {
  data() {
    return {
      mediaBase: mediaBase,
      accounts: [],
      uploadProgress: 0,
      password: '',
      passwordVisible: false,
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),

    scorePassword() {
      let score = 0;
      if (!this.password)
        return score;

      // award every unique letter until 5 repetitions
      let letters = new Object();
      for (let i = 0; i < this.password.length; i++) {
        letters[this.password[i]] = (letters[this.password[i]] || 0) + 1;
        score += 5.0 / letters[this.password[i]];
      }

      // bonus points for mixing it up
      let variations = {
        digits: /\d/.test(this.password),
        lower: /[a-z]/.test(this.password),
        upper: /[A-Z]/.test(this.password),
        nonWords: /\W/.test(this.password),
      }

      let variationCount = 0;
      for (let check in variations) {
        variationCount += (variations[check] === true) ? 1 : 0;
      }
      score += (variationCount - 1) * 10;

      score = parseInt((score / 20) + "");
      //TODO LANGUAGE
      switch (score) {
        case 0:
          return {name: this.$t("passwordChange.risk"), percent: 10, score: score, color: 'danger'};
        case 1:
          return {name: this.$t("passwordChange.texmin"), percent: 30, score: score, color: 'danger'}
        case 2:
          return {name: this.$t("passwordChange.zeif"), percent: 50, score: score, color: 'warning'}
        case 3:
          return {name: this.$t("passwordChange.guclu"), percent: 70, score: score, color: 'primary'}
        case 4:
          return {name: this.$t("passwordChange.secure"), percent: 100, score: score, color: 'success'}
        default:
          return {name: this.$t("passwordChange.namelum"), percent: 0, score: score, color: 'dark'}
      }
    },
  },
  mounted() {

    this.getUserProfile();

    userAccounts(this.token).then(data => {
      this.accounts = data;
    })

  },
  methods: {

    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getUserProfile() {
      userMe(this.token).then(({code, message, type, user, company, profileType, position}) => {

        if (code === 200) {

          store.dispatch('auth/setUser', user);
          store.dispatch('auth/setCompany', company);
          store.dispatch('auth/setProfile', profileType);
          store.dispatch('auth/setPosition', position);
          store.dispatch('auth/setSessionType', type);

        } else if (code === 401) {
          localStorage.removeItem("token");
          return this.$router.push("/auth/login");
        } else {
          this.$swal({
            title: `Error ${code}`,
            text: `${message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }

      })
    },
    removeProfilePhoto() {
      if (confirm(this.$t("userProfile.sklSlmkIstdyn"))) {
        removeProfilePhoto(this.token).then(data => {
          if (data.code === 200) {
            this.getUserProfile();
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      }
    },

    deleteAccount() {

      this.$swal({
        title: this.$t("userProfile.hsbnzSlmzSbbQyd"),
        input: 'text',
        icon: 'question',
        inputPlaceholder: this.$t("request.sbb"),
        showCancelButton: true,
        confirmButtonText: this.$t("userProfile.hesabmSil"),
        cancelButtonText: this.$t("companyProfile.lvEt2"),
      }).then((result) => {
        if (result.value) {
          deleteAccount(this.token, result.value).then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("userProfile.hsbnzSldi"),
                icon: 'success'
              }).then(() => {
                this.$router.replace('/');
              })
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          })
        }
      });
    },

    changeEmail() {
      this.$swal({
        title: this.$t("userProfile.ynMlnzDxlEdin"),
        text: this.$t("userProfile.brMlYlnzHsb"),
        input: 'email',
        icon: 'question',
        inputPlaceholder: 'e-mail',
        showCancelButton: true,
        confirmButtonText: this.$t("userProfile.mlDys"),
        cancelButtonText: this.$t("companyProfile.lvEt2"),
      }).then((result) => {


        if (result.value) {

          if (result.value === this.user.email) {
            return this.$swal({
              title: this.$t("generalModal.warningTitle"),
              text: this.$t("userProfile.ynMlnzkhnMlndnFrql"),
              icon: 'warning'
            })
          }

          changeEmail(this.token, result.value).then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("userProfile.mlnzYnlnd"),
                icon: 'success'
              }).then(() => {
                this.getUserProfile();
              })
            } else if (data.code === 409) {
              this.$swal({
                title: this.$t("generalModal.warningTitle"),
                text: this.$t("userProfile.buMlArtqIstfdOlnr"),
                icon: 'warning'
              }).then(() => {
                this.getUserProfile();
              })
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          })
        }
      });
    },

    changePassword() {
      this.$bvModal.show('modal-edit-password');
    },

    setPassword() {

      if (this.scorePassword.percent <= 50) {
        return this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("passwordChange.message"),
          icon: 'warning'
        })
      }

      userSetPassword(this.token, this.password).then(({code, message, token}) => {

        if (code === 200) {
          this.$swal({
            title: this.$t("congratulations"),
            text: this.$t("userProfile.sfrnzUgrlDysdrl"),
            icon: 'success',
          }).then(() => {
            this.getUserProfile();
            this.$bvModal.hide('modal-edit-password');
          })
        } else if (code === 401 || code === 404) {
          this.$swal({
            title: this.$t("err"),
            text: this.$t("passwordChange.errorMessage"),
            icon: 'error',
          })
        } else {
          this.$swal({
            title: `Error ${code} !`,
            text: message,
            icon: 'error',
          })
        }

      });

    },
    selectPhoto() {
      window.document.getElementById('fileInput').click();
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'profilePhoto', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {

                updateProfilePhoto(this.token, response.data.path).then(data => {
                  if (data.code === 200) {
                    this.getUserProfile();
                  } else {
                    this.$swal({
                      title: `Error ${data.code}`,
                      text: `${data.message}`,
                      icon: 'error'
                    })
                  }
                })

              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {
              this.progress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("request.cldNotUploadFile") + e,
                icon: 'error'
              })
            });

      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("request.photoUploadNotSpprtdBrowser"),
          icon: 'error'
        })
      }
    }
  }

}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
